var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { memo } from 'react';
import { RectangularCoordinate } from '~/components/RectangularCoordinate';
import { BoxElement } from '~/components/BoxElement';
import { Console } from '~/components/Console';
import { useRecoilState } from 'recoil';
import { boxesState } from './state/boxes';
var MemorizedConsole = memo(Console);
function App() {
    var _a = __read(useRecoilState(boxesState), 2), boxes = _a[0], setBoxes = _a[1];
    var handleChangeBox = function (changedBox) {
        setBoxes(function (boxes) {
            var index = boxes.findIndex(function (box) { return box.name === changedBox.name; });
            if (index === -1)
                return boxes;
            return __spreadArray(__spreadArray(__spreadArray([], __read(boxes.slice(0, index)), false), [changedBox], false), __read(boxes.slice(index + 1)), false);
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(RectangularCoordinate, null),
        boxes.map(function (box) { return (React.createElement(BoxElement, { key: box.name, box: box, onChangeBox: handleChangeBox })); }),
        React.createElement(MemorizedConsole, null)));
}
export { App };
